export class CareerLocation{
    public location:string;
    public offices:CareerOffice[] = [];
}

export class CareerOffice{
    public name:string;
    public url:string;
}
